import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-xl font-semibold text-white transition-all duration-300 rounded-2xl shadow-lg hover:shadow-xl hover:-translate-y-1 bg-terracotta hover:bg-terracotta-light active:translate-y-0';
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} data-id="element-18">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} {...props} data-id="element-19">
      {children}
    </button>;
}